__turbopack_context__.v({
  "item": "banner-module-scss-module__5AFz5a__item",
  "item_icon": "banner-module-scss-module__5AFz5a__item_icon",
  "item_price": "banner-module-scss-module__5AFz5a__item_price",
  "item_title": "banner-module-scss-module__5AFz5a__item_title",
  "logo_wrapper": "banner-module-scss-module__5AFz5a__logo_wrapper",
  "page_icon": "banner-module-scss-module__5AFz5a__page_icon",
  "page_logo": "banner-module-scss-module__5AFz5a__page_logo",
  "page_title": "banner-module-scss-module__5AFz5a__page_title",
  "slider": "banner-module-scss-module__5AFz5a__slider",
  "wrapper": "banner-module-scss-module__5AFz5a__wrapper",
});
